module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel",
    style: (_vm.getStyle)
  }, [_c('div', {
    staticClass: "carousel_head"
  }, [_c('h3', {
    staticClass: "carousel_head__title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "carousel_head__control-panel"
  }, [(!_vm.flexWrap) ? [_c('button', {
    staticClass: "carousel_btn",
    attrs: {
      "disabled": _vm.carousel.data && _vm.carousel.data.isFirstSlide
    },
    on: {
      "click": function($event) {
        return _vm.carousel.navigate.prevSlide()
      }
    }
  }, [_vm._v("<")]), _c('button', {
    staticClass: "carousel_btn",
    attrs: {
      "disabled": _vm.carousel.data && _vm.carousel.data.isLastSlide
    },
    on: {
      "click": function($event) {
        return _vm.carousel.navigate.nextSlide()
      }
    }
  }, [_vm._v(">")])] : _vm._e()], 2)]), _c('div', {
    staticClass: "divide_line",
    style: ({
      height: "4px",
      background: ("" + _vm.lineTitleColor),
      borderRadius: "2px"
    })
  }), _c('div', {
    staticClass: "carousel_content"
  }, [_c('ul', {
    ref: "carouselWrapper",
    staticClass: "carousel_content__list"
  }, [_vm._t("default"), (!_vm.isContent) ? _c('h4', {
    staticClass: "ui_color__light-gray"
  }, [_vm._v("Контент отсутствует")]) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0315a73c","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppDefaultLayout/components/parts/slider/StartPageSlider.vue
// module id = 7c41b389ea27551246ca
// module chunks = 0